export default "__VITE_ASSET__la$OaTa___"